import React from 'react'

const Heading = ({title}) => {
  return (
    <>
    <h2 className='heading' data-aos="fade-zoom-in">{title}</h2>
    </>
  )
}

export default Heading